import { v4 as uuidv4 } from 'uuid';

const redirectToSignup = ({
  productBusinessLine,
  skus,
  orderType,
  orderSubtotal,
}) => {
  const orderId = uuidv4();
  const idempotencyKey = uuidv4();
  const orderReviewParams = [
    `order[order_type]=${orderType}`,
    `order[order_id]=${orderId}`,
    `order[idempotency_key]=${idempotencyKey}`,
    `order[origin_url]=${window.location.href}`,
    `order[subtotal]=${orderSubtotal}`,
  ];

  skus.forEach(function (sku) {
    orderReviewParams.push(`order[skus][][qty]=${sku.quantity}`);
    orderReviewParams.push(`order[skus][][source]=${sku.source}`);
    orderReviewParams.push(`order[skus][][id]=${sku.id}`);

    if (sku.subSource) {
      orderReviewParams.push(
        `order[skus][][metadata][sub_source]=${sku.subSource}`,
      );
    } else {
      orderReviewParams.push(`order[skus][][metadata][sub_source]`);
    }
  });

  const orderReviewParamsString = orderReviewParams.join('&');

  window.location.assign(
    `/product/signup?business_line=${productBusinessLine}&order_review_params=${encodeURIComponent(
      orderReviewParamsString,
    )}`,
  );
};

export default redirectToSignup;
